import { DEFAULT_SUITE_SETTINGS, type SuiteSettings } from "./types";

const KEY = "chatforge.suite.v1";
export const SUITE_RELAY_URL = "https://bookforge-relay.forgesuiteui.app";

export function resolveDefaultForgeApiUrl(): string {
  if (typeof window === "undefined") return SUITE_RELAY_URL;
  const h = window.location.hostname.toLowerCase();
  if (h === "localhost" || h === "127.0.0.1" || h.endsWith(".local")) {
    return DEFAULT_SUITE_SETTINGS.forgeApiUrl;
  }
  return (
    (import.meta.env.VITE_RELAY_URL as string | undefined)?.replace(/\/$/, "") ||
    SUITE_RELAY_URL
  );
}

function isLocalRelay(url: string): boolean {
  return /localhost|127\.0\.0\.1/i.test(url || "");
}

function isBrokenOrigin(url: string): boolean {
  return /forge-origin-api\.coatedcanvas\.workers\.dev|forge-origin\.forgesuiteui\.app/i.test(
    url || "",
  );
}

export function loadSuiteSettings(): SuiteSettings {
  const prodDefault = resolveDefaultForgeApiUrl();
  if (typeof localStorage === "undefined") {
    return { ...DEFAULT_SUITE_SETTINGS, forgeApiUrl: prodDefault };
  }
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_SUITE_SETTINGS, forgeApiUrl: prodDefault };
    const parsed = { ...DEFAULT_SUITE_SETTINGS, ...JSON.parse(raw) } as SuiteSettings;
    if (
      !isLocalRelay(prodDefault) &&
      (isLocalRelay(parsed.forgeApiUrl) || isBrokenOrigin(parsed.forgeApiUrl))
    ) {
      parsed.forgeApiUrl = prodDefault;
    }
    if (!parsed.forgeApiUrl?.trim()) parsed.forgeApiUrl = prodDefault;
    return parsed;
  } catch {
    return { ...DEFAULT_SUITE_SETTINGS, forgeApiUrl: prodDefault };
  }
}

export function saveSuiteSettings(s: SuiteSettings): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(KEY, JSON.stringify(s));
}
